// extracted by mini-css-extract-plugin
export var imageBlock = "image_text-module--image-block--32OXo";
export var image = "image_text-module--image--1BFap";
export var imageText = "image_text-module--image-text--2Cdft";
export var imageRight = "image_text-module--image-right--1VPXo";
export var text = "image_text-module--text--rRxEv";
export var imageLeft = "image_text-module--image-left--1jP0Q";